import React, { useEffect, useState } from "react";
import eventEmitter from "../../shared/events";

import Notes from "./contexts/notes";
import NoteIcon from "./components/note-button";
import NotePopOut from "./note-popout";

const NoteLauncher = ({ sourcePage, ...props }) => {
    const [showNotes, setShowNotes] = useState(false);

    useEffect(() => {
        eventEmitter.on("TOGGLE_NOTES", toggleNotes);

        return () => eventEmitter.removeListener("TOGGLE_NOTES", toggleNotes);
    });

    const toggleNotes = (bool) => {
        const useBool = bool ? bool : !showNotes;
        setShowNotes(useBool);
    };

    return (
        <div>
            <Notes
                settings={props.settings}
                clientCode={props.clientCode}
                binTrackingNumber={props.binTrackingNumber}
                noteType={props.noteType}
                taskType={props.taskType}
                sourcePage={sourcePage}
            >
                <NoteIcon showNotes={showNotes} toggleNotes={toggleNotes} />
                {showNotes && <NotePopOut upc={props.upc} toggleNotes={toggleNotes} taskType={props.taskType} isReadOnly={props.isReadOnly} />}
            </Notes>
        </div>
    );
};

export default NoteLauncher;
